export const OrderType = [
  'CARD_ORDER',
  'PIN_MAIL_ORDER'
]
